import Apple from './svg/Apple.svg'
import FacebookThirdParty from './svg/Facebook-third-party.svg'
import Facebook from './svg/Facebook.svg'
import Google from './svg/Google.svg'
import Instagram from './svg/Instagram.svg'
import Line from './svg/Line.svg'
import Twitter from './svg/Twitter.svg'
import AllEmpty from './svg/all-empty.svg'
import ArrowDown from './svg/arrow-down.svg'
import ArrowDownThick from './svg/arrow-down-thick.svg'
import ArrowExternal from './svg/arrow-external.svg'
import ArrowLeftWithoutSize from './svg/arrow-left-without-size.svg'
import ArrowLeft from './svg/arrow-left.svg'
import ArrowRight from './svg/arrow-right.svg'
import Arrow from './svg/arrow.svg'
import Attention from './svg/attention.svg'
import Avatar from './svg/avatar.svg'
import Background from './svg/background.svg'
import Bag from './svg/bag.svg'
import Beauty from './svg/beauty.svg'
import Burger from './svg/burger.svg'
import Calendar from './svg/calendar.svg'
import CameraOff from './svg/camera-off.svg'
import Camera from './svg/camera.svg'
import CartAdd from './svg/cart-add.svg'
import Chat from './svg/chat.svg'
import Check from './svg/check.svg'
import ChevronRight from './svg/chevron-right.svg'
import Clear from './svg/clear.svg'
import CloseSM from './svg/close-sm.svg'
import Close from './svg/close.svg'
import Coffee from './svg/coffee.svg'
import Copy from './svg/copy.svg'
import Coupon from './svg/coupon.svg'
import DailyLife from './svg/dailylife.svg'
import Deliver from './svg/deliver.svg'
import Device from './svg/device.svg'
import Dropdown from './svg/dropdown.svg'
import Earth from './svg/earth.svg'
import EditHead from './svg/edit-head.svg'
import Edit from './svg/edit.svg'
import Email from './svg/email.svg'
import Empty from './svg/empty.svg'
import Enter from './svg/enter.svg'
import ExclamationMark from './svg/exclamation_mark.svg'
import EyeClose from './svg/eye-close.svg'
import EyeClose_Wide from './svg/eye-close_white.svg'
import EyeOpen from './svg/eye-open.svg'
import EyeOpen_HollowEyeball from './svg/eye-open_hollow-eyeball.svg'
import Failure from './svg/failure.svg'
import FastBack from './svg/fast-back.svg'
import FastForward from './svg/fast-forward.svg'
import FieldClear from './svg/field-clear.svg'
import Filming from './svg/filming.svg'
import Fullscreen from './svg/fullscreen.svg'
import Good from './svg/good.svg'
import HangUp from './svg/hang-up.svg'
import Hanger from './svg/hanger.svg'
import HealthFood from './svg/healthfood.svg'
import Heart from './svg/heart.svg'
import HollowShare from './svg/hollow-share.svg'
import Hot from './svg/hot.svg'
import Hourglass from './svg/hourglass.svg'
import Human from './svg/human.svg'
import Icecream from './svg/icecream.svg'
import Follow_White from './svg/icon-follow-white.svg'
import IGSetting from './svg/ig-setting.svg'
import Info from './svg/info.svg'
import InputClear from './svg/input-clear.svg'
import Joy from './svg/joy.svg'
import Like from './svg/like.svg'
import Lines from './svg/lines.svg'
import AccordionArrow from './svg/live-mall-club/accordion-arrow.svg'
import AddressEmpty from './svg/live-mall-club/address-empty.svg'
import Alarm from './svg/live-mall-club/alarm.svg'
import LMC_ArrowDown from './svg/live-mall-club/arrow-down.svg'
import ArrowRight_LiveMallClub from './svg/live-mall-club/arrow-right-lmb.svg'
import Check_LiveMallClub from './svg/live-mall-club/check_lmb.svg'
import Clock from './svg/live-mall-club/clock.svg'
import Clock_303030 from './svg/live-mall-club/clock_303030.svg'
import Close_XS from './svg/live-mall-club/close_xs.svg'
import DefaultHeadShot from './svg/live-mall-club/default-headshot.svg'
import Diamond from './svg/live-mall-club/diamond.svg'
import Download from './svg/live-mall-club/download.svg'
import Email_bf1424 from './svg/live-mall-club/email-bf1424.svg'
import L_Email from './svg/live-mall-club/email.svg'
import ShopEmpty from './svg/live-mall-club/empty_shop.svg'
import SocialFacebook from './svg/live-mall-club/facebook.svg'
import Home from './svg/live-mall-club/home.svg'
import HourGlass_Live_Mall_Club from './svg/live-mall-club/hourglass.svg'
import Follow from './svg/live-mall-club/icon-follow.svg'
import LiveNowTag from './svg/live-mall-club/live-now-tag.svg'
import Lock from './svg/live-mall-club/lock.svg'
import MenuArrow from './svg/live-mall-club/menu-arrow.svg'
import Address from './svg/live-mall-club/menu/address.svg'
import BecomeKOL from './svg/live-mall-club/menu/become-kol.svg'
import MenuCoupon from './svg/live-mall-club/menu/coupon.svg'
import Logout from './svg/live-mall-club/menu/logout.svg'
import Notification from './svg/live-mall-club/menu/notification.svg'
import Order from './svg/live-mall-club/menu/order.svg'
import Security from './svg/live-mall-club/menu/security.svg'
import MenuStore from './svg/live-mall-club/menu/store.svg'
import Term from './svg/live-mall-club/menu/term.svg'
import MoreOption from './svg/live-mall-club/more.svg'
import Mute from './svg/live-mall-club/mute.svg'
import MyLiveListEmpty from './svg/live-mall-club/my-live-list-empty.svg'
import OpenLink from './svg/live-mall-club/open-link.svg'
import Pencil from './svg/live-mall-club/pencil.svg'
import Photo from './svg/live-mall-club/photo.svg'
import Pinned from './svg/live-mall-club/pin.svg'
import Plus_LiveMallClub from './svg/live-mall-club/plus_lmc.svg'
import PointRight from './svg/live-mall-club/point-right.svg'
import Product from './svg/live-mall-club/product.svg'
import ShoppingCart_bf1424 from './svg/live-mall-club/shopping-cart-bf1424.svg'
import Sorter from './svg/live-mall-club/sorter.svg'
import ThumbUp from './svg/live-mall-club/thumb-up.svg'
import TrashCanRounded from './svg/live-mall-club/trashcan-rounded.svg'
import Video from './svg/live-mall-club/video.svg'
import Warning from './svg/live-mall-club/warning.svg'
import SocialWebsite from './svg/live-mall-club/website.svg'
import MemberV2 from './svg/member-v2.svg'
import CouponV2 from './svg/coupon-v2.svg'
import WalletV2 from './svg/wallet-v2.svg'
import AddressV2 from './svg/address-v2.svg'
import UploadV2 from './svg/upload-v2.svg'
import BriefcaseV2 from './svg/briefcase-v2.svg'
import CheckCircleV2 from './svg/check-circle-v2.svg'
import HeartV2 from './svg/heart-v2.svg'
import PaymentCard from './svg/payment-card.svg'
import Location from './svg/location.svg'
import LogoStrawberry from './svg/logo-strawberry.svg'
import Logo from './svg/logo.svg'
import LongHandleSearch from './svg/long-handle-search.svg'
import Magnifier from './svg/magnifier.svg'
import MenuLine from './svg/menu-line.svg'
import MicConnect from './svg/mic-connect.svg'
import MicIcecream from './svg/mic-icecream.svg'
import MicOff from './svg/mic-off.svg'
import Mic from './svg/mic.svg'
import Microphone from './svg/microphone.svg'
import MobileBackground from './svg/mobile-background.svg'
import Mobile from './svg/mobile.svg'
import MoreShare from './svg/more-share.svg'
import MoreTrend from './svg/more-trend.svg'
import More from './svg/more.svg'
import Pause from './svg/pause.svg'
import Pet from './svg/pet.svg'
import PhoneClose from './svg/phone-close.svg'
import Pin from './svg/pin.svg'
import PipPlayerExpand from './svg/pip-player-expand.svg'
import PipPlayer from './svg/pip-player.svg'
import PlayOrigin from './svg/play-origin.svg'
import Play from './svg/play.svg'
import Plus from './svg/plus.svg'
import PopularZoneIconBrand from './svg/popular-zone-icon-brand.svg'
import PopularZoneIconProduct from './svg/popular-zone-icon-product.svg'
import Protect from './svg/protect.svg'
import Purchase from './svg/purchase.svg'
import Rocket from './svg/rocket.svg'
import RoomShare from './svg/room-share.svg'
import Rotate from './svg/rotate.svg'
import SearchMagnifier from './svg/search-magnifier.svg'
import Search from './svg/search.svg'
import Send from './svg/send.svg'
import Setting from './svg/setting.svg'
import ShareFacebook from './svg/share-facebook.svg'
import ShareInstagram from './svg/share-instagram.svg'
import ShareLine from './svg/share-line.svg'
import ShareLink from './svg/share-link.svg'
import Share from './svg/share.svg'
import ShopBag from './svg/shopbag.svg'
import ShopBagGradient from './svg/shopbag_gradient.svg'
import ShoppingCartBlack from './svg/shopping-cart-black.svg'
import ShoppingCartWhite from './svg/shopping-cart-white.svg'
import SignalOrigin from './svg/signal-origin.svg'
import Signal from './svg/signal.svg'
import SignalGradient from './svg/signal_gradient.svg'
import SoundOff from './svg/sound-off.svg'
import Sound from './svg/sound.svg'
import Speaker from './svg/speaker.svg'
import Store from './svg/store.svg'
import Streaming from './svg/streaming.svg'
import Success from './svg/success.svg'
import Switch from './svg/switch.svg'
import Text from './svg/text.svg'
import Trashcan from './svg/trashcan.svg'
import Trend from './svg/trend.svg'
import TypeEmpty from './svg/type-empty.svg'
import Vegetable from './svg/vegetable.svg'
import WifiOff from './svg/wifi-off.svg'
import Wifi from './svg/wifi.svg'
import Document from './svg/live-mall-club/document.svg'
import ClearFilled from './svg/live-mall-club/clear-filled.svg'
import Download_AppStore from './svg/download_appStore.svg'
import Download_GooglePlay from './svg/download_googlePlay.svg'
import ShopNotification from './svg/notification.svg'
import ShopNotificationWhite from './svg/notification-white.svg'
import ShopNotificationBlack from './svg/notification-black.svg'
import SortDescend from './svg/sort-descend.svg'
import SortAscend from './svg/sort-ascend.svg'
import Question from './svg/question-circle.svg'

const Icon = {
  Logo,
  LogoStrawberry,
  Background,
  MobileBackground,
  Avatar,
  Signal,
  ChevronRight,
  Hanger,
  Protect,
  Heart,
  Magnifier,
  Share,
  Send,
  Good,
  Vegetable,
  Beauty,
  Pet,
  Speaker,
  Icecream,
  Rocket,
  Like,
  CartAdd,
  MicIcecream,
  ArrowRight,
  Bag,
  ArrowDown,
  ArrowDownThick,
  LMC_ArrowDown,
  Success,
  Failure,
  Copy,
  ArrowLeft,
  ArrowLeftWithoutSize,
  Close,
  Dropdown,
  Arrow,
  ShopBag,
  Burger,
  Facebook,
  Instagram,
  Twitter,
  Microphone,
  Store,
  Chat,
  HollowShare,
  Device,
  HealthFood,
  DailyLife,
  Joy,
  Deliver,
  Edit,
  EditHead,
  Trashcan,
  Pin,
  Attention,
  PhoneClose,
  Mic,
  MicOff,
  Camera,
  CameraOff,
  Sound,
  SoundOff,
  Wifi,
  WifiOff,
  HangUp,
  Switch,
  Trend,
  Empty,
  Enter,
  FieldClear,
  Search,
  Info,
  MicConnect,
  Google,
  Line,
  Apple,
  FacebookThirdParty,
  Email,
  Mobile,
  Coffee,
  Filming,
  Lines,
  Purchase,
  Plus,
  More,
  MoreShare,
  MoreTrend,
  ShareLink,
  ShareLine,
  ShareInstagram,
  ShareFacebook,
  RoomShare,
  FastForward,
  FastBack,
  Play,
  Pause,
  EyeOpen,
  EyeClose,
  MenuLine,
  Rotate,
  Fullscreen,
  PipPlayer,
  PipPlayerExpand,
  Coupon,
  Check,
  Text,
  IGSetting,
  ArrowExternal,
  SignalOrigin,
  PlayOrigin,
  Human,
  CloseSM,
  LongHandleSearch,
  SearchMagnifier,
  InputClear,
  Earth,
  Setting,
  Calendar,
  ShoppingCartWhite,
  ShoppingCartBlack,
  ShopBagGradient,
  SignalGradient,
  ExclamationMark,
  Hourglass,
  PopularZoneIconBrand,
  PopularZoneIconProduct,
  Hot,
  Home,
  MenuArrow,
  Follow,
  Alarm,
  Pencil,
  DefaultHeadShot,
  Photo,
  Pinned,
  Mute,
  MoreOption,
  Sorter,
  L_Email,
  MyLiveListEmpty,
  Clock,
  Clock_303030,
  HourGlass_Live_Mall_Club,
  Video,
  Clear,
  AllEmpty,
  TypeEmpty,
  ArrowRight_LiveMallClub,
  Location,
  SocialFacebook,
  SocialWebsite,
  Address,
  BecomeKOL,
  MenuCoupon,
  MenuStore,
  Logout,
  Notification,
  Order,
  Security,
  Term,
  Follow_White,
  EyeOpen_HollowEyeball,
  EyeClose_Wide,
  ShopEmpty,
  AccordionArrow,
  Product,
  ShoppingCart_bf1424,
  Email_bf1424,
  LiveNowTag,
  Diamond,
  TrashCanRounded,
  ThumbUp,
  Check_LiveMallClub,
  Plus_LiveMallClub,
  Warning,
  Download,
  OpenLink,
  Close_XS,
  PointRight,
  AddressEmpty,
  Lock,
  Document,
  ClearFilled,
  Streaming,
  Download_AppStore,
  Download_GooglePlay,
  ShopNotification,
  ShopNotificationWhite,
  ShopNotificationBlack,
  SortDescend,
  SortAscend,
  Question,
  MemberV2,
  CouponV2,
  WalletV2,
  AddressV2,
  UploadV2,
  BriefcaseV2,
  CheckCircleV2,
  HeartV2,
  PaymentCard,
}

export default Icon
